import React, {FC, useEffect, useState} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import SignaturePad from 'react-signature-pad-wrapper'
import Swal from 'sweetalert2'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {
  createCheckinService,
  createCheckoutService,
  uploadSignatureGuestService,
} from '../../../services/checking.service'
import {getTermsService} from '../../tyc/services'
import {downloadPDFCheckInOutService} from '../../../services/booking.service'
import {getSnackBarToast} from '../../../../../util/snackBar'

interface Props {
  prevStep: () => void
  nextStep: () => void
  stepper: any
  goToFirstStep: () => void
  goToStep: (index: number) => void
}

const FormStep3Auto: FC<Props> = ({prevStep, nextStep, stepper, goToFirstStep, goToStep}) => {
  const {
    // register,
    setValue,
    watch,
    // control,
    // formState: {errors},
    // setError,
  } = useFormContext()

  console.log(watch())

  const [isChekingTyc, setIsChekingTyc] = useState(true)
  const signaturePadRef = React.createRef<SignaturePad>()
  const [isLoadingResult, setIsLoadingResult] = useState(false)
  const [tycText, setTycText] = useState('')
  const [hasTyc, setHasTyC] = useState(false)
  const [isLoadingCheck, setIsLoadingCheck] = useState(false)
  const [operationMessageError, setOperationMessageError] = useState('')

  const tipoDocumento_descripcion = useWatch({name: 'tipoDocumento_descripcion'})
  const numeroDocumento = useWatch({name: 'numeroDocumento'})
  const [timerI, setTimer] = useState(20)
  const bookingItem = useWatch({name: 'bookingItem'})
  const isGuest = useWatch({name: 'isGuest'})
  // const modAutoservicioTotem = useWatch({name: 'ModAutoservicioTotem'})
  const operationType = useWatch({name: 'operationType'})
  const huespedId = useWatch({name: 'HuespedId'})
  const reservaId = useWatch({name: 'ReservaId'})
  const camaId = useWatch({name: 'CamaId'})
  const aceptaTyC = useWatch({name: 'AceptaTyC'})
  const companiaId = useWatch({name: 'CompaniaId'})
  const clienteId = useWatch({name: 'ClienteId'})
  const siteId = useWatch({name: 'SiteId'})
  const reservaCamaId = useWatch({name: 'ReservaCamaId'})
  const errorCheck = useWatch({name: 'errorCheck'})

  useEffect(() => {
    // Start the timer countdown when the component mounts
    const intervalId = setInterval(() => {
      setTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0))
    }, 1000)
    if (!aceptaTyC && isGuest && huespedId) {
      handlePaginationTerms()
      setTimer(60)
    } else {
      setIsChekingTyc(false)
    }

    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId)
  }, [])

  useEffect(() => {
    // Perform an action when the timer reaches 0
    if (timerI === 0) {
      if (!aceptaTyC) {
        ShowQuestionTimmer()
      } else {
        // Assuming you have access to stepper.current in the scope of this component
        // Replace this with your actual logic to go to step 1
        //   stepper.current.goto(1)
        goToFirstStep()
      }
    }
  }, [timerI])

  const handleSubmit = async () => {
    if (operationType === 'checkin') {
      handleCheckIn()
    } else {
      handleCheckout()
    }
  }

  const handleCheckIn = async () => {
    try {
      setIsLoadingCheck(true)
      const {data: response} = await createCheckinService({
        ReservaId: reservaId,
        CamaId: camaId,
        HuespedId: huespedId,
      })
      if (response.error) {
        await setValue('errorCheck', true)
        setOperationMessageError(response.message)

        setValue('fromFinish', false)
        setIsLoadingCheck(false)
        return
      }
      setIsLoadingCheck(false)
      setValue('fromFinish', false)

      let dto = {
        reservaCamaId: response.ReservaCamaId,
        tipo: 'IN',
        MotivoReimpresionId: '',
        Otros: '',
      }
      const resp = await downloadPDFCheckInOutService(dto)
      const blob = new Blob([resp.data], {type: 'application/pdf'})
      let url = window.URL.createObjectURL(blob)
      setTimeout(() => {
        printPdf(url)
      }, 1000)
      Swal.fire({
        title: 'Se ha realizado el check-in',
        html: `<div id="print_pdf">
              <button
                id='printButton'
                class='sdx_btn m-auto'
                type='button'
              >Imprimir Ticket Checkin</button>
            </div>`,
        icon: 'success',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        didOpen: () => {
          const printButton = document.getElementById('printButton') as HTMLElement
          printButton.addEventListener('click', () => printPdf(url))
        },
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          Swal.close()
        }
      })
    } catch (error: any) {
      getSnackBarToast(error?.response?.message, 'error')
      console.log({error})
      // Handle error
    }
  }

  const printPdf = (pdfUrl: any) => {
    const printWindow = window.open(pdfUrl, '_blank')
    if (printWindow) {
      printWindow.addEventListener('load', () => {
        printWindow.focus()
        printWindow.print()
      })
    }
  }

  const handleCheckout = async () => {
    try {
      setIsLoadingCheck(true)
      const {data: response} = await createCheckoutService({
        ReservaId: reservaId,
        CamaId: camaId,
        HuespedId: huespedId,
      })

      if (response.error) {
        setValue('errorCheck', true)
        setOperationMessageError(response.message)
        setIsLoadingCheck(false)
        setValue('fromFinish', false)
        return
      }
      setIsLoadingCheck(false)
      setValue('fromFinish', false)
      let dto = {
        reservaCamaId: reservaCamaId,
        tipo: 'OUT',
        MotivoReimpresionId: '',
        Otros: '',
      }
      const resp = await downloadPDFCheckInOutService(dto)
      const blob = new Blob([resp.data], {type: 'application/pdf'})
      let url = window.URL.createObjectURL(blob)
      setTimeout(() => {
        printPdf(url)
      }, 1000)
      Swal.fire({
        title: 'Se ha realizado el check-out',
        html: `<div id="print_pdf">
              <button
                id='printButton'
                class='sdx_btn m-auto'
                type='button'
              >Imprimir Ticket Checkout</button>
            </div>`,
        icon: 'success',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        didOpen: () => {
          const printButton = document.getElementById('printButton') as HTMLElement
          printButton.addEventListener('click', () => printPdf(url))
        },
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          Swal.close()
        }
      })
    } catch (error) {
      // Handle error
    }
  }

  const handleGoStep2 = async () => {
    goToStep(2)
  }

  const handlePaginationTerms = async () => {
    // const {data: response} = await getTermsService({
    //   CompaniaId: companiaId,
    //   ClienteId: clienteId,
    //   SiteId: siteId,
    //   pageNumber: 1,
    //   size: 10,
    // })
    // if (!response.error && response.data.length > 0 && response.data[0].TyC) {
    //   if (response.data[0].ModAutoservicioTotem) {
    //     setTycText(response.data[0].TyC)
    //     setHasTyC(true)
    //   } else {
    //     await handleSubmit()
    //     setHasTyC(false)
    //     // await setValue('AceptaTyC', true) // No se le permite firmar TyC
    //     //@todo("Poner Loading");
    //   }
    // } else {
    //   await handleSubmit()
    //   setHasTyC(false)
    // }
    setIsChekingTyc(false)
    await handleSubmit()
    setHasTyC(false)
  }

  const ShowQuestionTimmer = async () => {
    let timerInterval: any = null
    Swal.fire({
      confirmButtonText: 'Si',
      didOpen: () => {
        //Swal.showLoading();
        // const timer = Swal.getPopup().querySelector("b");
        // timerInterval = setInterval(() => {
        //   timer.textContent = `${Swal.getTimerLeft()}`;
        // }, 100);
      },
      showConfirmButton: true,
      //  showDenyButton:true,
      //html: "I will close in <b></b> milliseconds.",
      timer: 5000,
      timerProgressBar: true,
      title: '¿Sigues ahí?',
      willClose: () => {
        clearInterval(timerInterval)
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setTimer(60)
      } else {
        goToFirstStep()
      }
      /* Read more about handling dismissals below */
      // if (result.dismiss === Swal.DismissReason.timer) {
      // }
    })
  }

  const handleClearSignature = async () => {
    const signaturePad = signaturePadRef.current
    signaturePad?.clear()
  }

  const handleSaveSing = async () => {
    const signaturePad = signaturePadRef.current

    if (!signaturePad) {
      return
    }

    if (signaturePad.isEmpty()) {
      // eslint-disable-next-line no-alert
      Swal.fire('El huesped debe firmar primero.', '', 'warning')
    } else {
      setIsLoadingResult(true)
      let imageValue = signaturePad.toDataURL()
      const binaryData = atob(imageValue.replace('data:image/png;base64,', ''))
      const arrayBuffer = new ArrayBuffer(binaryData.length)
      const uint8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i)
      }
      //window.open(signaturePad.toDataURL());
      const blob = new Blob([uint8Array])
      const formData = new FormData()
      formData.append('file', blob, `Firma-${huespedId}.png`)

      const response = await uploadSignatureGuestService(formData, huespedId)
      setIsLoadingResult(false)
      if (!response.data.error) {
        handleSubmit()
      } else {
        Swal.fire('No hemos podido guardar la firma', 'Intentalo nuevamente', 'error')
        //handleExit();
      }
    }
  }

  return (
    <div className='w-100'>
      {isChekingTyc || isLoadingCheck ? (
        <div className='d-flex flex-column align-items-center mt-3'>
          <span className='indicator-progress' style={{display: 'block'}}>
            Verificando...
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
        </div>
      ) : (
        <>
          <div className='mt-1'>
            <p>
              Tiempo restante: <span>{timerI}</span> segundos
            </p>
          </div>
          {!aceptaTyC && isGuest && huespedId && hasTyc ? (
            <div className='d-flex justify-content-center flex-column align-items-center'>
              {tycText ? (
                <div className='d-flex flex-column align-items-center mt-3'>
                  {/*<span className='indicator-progress' style={{display: 'block'}}>*/}
                  {/*  Verificando...*/}
                  {/*  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>*/}
                  {/*</span>*/}
                  <h2>Terminos y condiciones</h2>
                  {/*<textarea className='form-control border-0 p-0 pe-10 resize-none min-h-25px'*/}
                  {/*          data-kt-autosize='true'*/}
                  {/*          disabled={true}*/}
                  {/*          rows={20}*/}
                  {/*          placeholder='Reply..'>{ tycText }</textarea>*/}
                  <div
                    className={
                      'form-control border-1 p-3 justify-content-center resize-none h-25 overflow-scroll'
                    }
                    dangerouslySetInnerHTML={{__html: tycText}}
                  ></div>
                  <h4 className={'mt-3'}>Firma:</h4>
                  <div className='border mt-2'>
                    <SignaturePad redrawOnResize ref={signaturePadRef} width={500} height={150} />
                  </div>
                  <div className={'mt-3'}>
                    {' '}
                    (
                    <button
                      onClick={handleClearSignature}
                      type={'button'}
                      className={'btn btn-link'}
                    >
                      Borrar firma
                    </button>
                    ){' '}
                  </div>
                  <div className='d-flex flex-stack pt-15'>
                    <div className='mr-2'>
                      <button
                        type='button'
                        className='btn btn-lg btn-light-primary me-3'
                        onClick={handleSaveSing}
                        disabled={isLoadingResult}
                      >
                        {!isLoadingResult && <span className='indicator-label'>Aceptar</span>}
                        {isLoadingResult && (
                          <span className='indicator-progress' style={{display: 'block'}}>
                            Enviando...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                      <button
                        type='button'
                        className='btn btn-lg btn-light-primary me-3'
                        data-kt-stepper-action='previous'
                        onClick={handleGoStep2}
                      >
                        Atras
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='d-flex flex-column align-items-center mt-3'>
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Verificando...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                </div>
              )}
            </div>
          ) : (
            <>
              {!isGuest || !!!huespedId ? (
                <div className='d-flex justify-content-center flex-column align-items-center'>
                  <div>
                    <img alt='Exito' src={toAbsoluteUrl('/media/logos/close.png')} />
                  </div>
                  <div className='d-flex flex-column align-items-center mt-3'>
                    <div className='fs-1 fw-bolder'>No se encontraron reservas activas</div>
                  </div>
                </div>
              ) : (
                <>
                  {errorCheck ? (
                    <div className='d-flex justify-content-center flex-column align-items-center'>
                      <div>
                        <img alt='Exito' src={toAbsoluteUrl('/media/logos/close.png')} />
                      </div>
                      <div className='d-flex flex-column align-items-center mt-3'>
                        <div className='fs-1 fw-bolder'>{`Hubo un error al hacer ${
                          operationType === 'checkin' ? 'CheckIn' : 'CheckOut'
                        }`}</div>
                        <div className='fs-4 fw-bolder'>{operationMessageError}</div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className='d-flex justify-content-center flex-column align-items-center'
                      style={{border: '1px solid red;'}}
                    >
                      <div>
                        <img alt='Exito' src={toAbsoluteUrl('/media/logos/check.png')} />
                      </div>
                      <div className='d-flex flex-column align-items-center mt-3'>
                        <div className='fs-1 fw-bolder'>Éxito</div>
                        <div className='fs-3 fw-bolder'>{`${
                          operationType === 'checkin' ? 'CheckIn' : 'CheckOut'
                        } exitoso`}</div>
                        <div className='fs-4 fw-bolder'>{`Su Información ha sido grabada con éxito`}</div>
                      </div>
                    </div>
                  )}
                </>
              )}

              <div className='d-flex flex-stack pt-15 justify-content-between'>
                <button
                  type='button'
                  className='btn btn-lg btn-light-primary me-3'
                  data-kt-stepper-action='previous'
                  onClick={handleGoStep2}
                >
                  Atras
                </button>
              </div>
            </>
          )}
        </>
      )}

      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
    </div>
  )
}

export {FormStep3Auto}
